import { gql } from "@apollo/client";

export const GET_ALLOCATION_RULES = gql`
  query allocationRules {
    allocationRules {
    	id
    	tenantId
    	organisationId
    	category
    	allocationRules {
    	  ruleCategory
    	  rules {
    	    ruleName
    	    sequence
    	    value
    	    operator
    	    distanceInKm
    	  }
    	  priority
    	  isActive
    	}
  	}
  }
`;

export const SAVE_ALLOCATION_RULES = gql`
  mutation saveAllocationRules($allocationRules: [AllocationRuleInput]!) {
    saveAllocationRules(allocationRules: $allocationRules) {
      id
    	tenantId
    	organisationId
    	category
    	allocationRules {
    	  ruleCategory
    	  rules {
    	    ruleName
    	    sequence
    	    value
    	    operator
    	    distanceInKm
    	  }
    	  priority
    	  isActive
    	}
    }
  }
`;

export const GET_ALLOCATION_RULES_BY_CATEGORIES = gql`
  query allocationRulesByCategories($categories: [String]!) {
    allocationRulesByCategories(categories: $categories) {
    	id
    	tenantId
    	organisationId
    	category
    	allocationRules {
    	  ruleCategory
    	  rules {
    	    ruleName
    	    sequence
    	    value
    	    operator
    	    distanceInKm
    	  }
    	  priority
    	  isActive
    	}
  	}
  }
`;
